export default class Switch {
  constructor (onOffSwitchWrapper) {
    this.onOffSwitchWrapper = onOffSwitchWrapper
    this.header = document.querySelector('#site-header')
    this.hero = document.querySelector('.hero')
    this.footer = document.querySelector('#footer')
    this.heroImageWrapper = document.querySelector('.hero--switch__image')
    this.anchorButton = document.querySelector('.hero--anchor')
    this.checkbox = onOffSwitchWrapper.querySelector('input')
    this.onOffSwitch = onOffSwitchWrapper.querySelector('.onoffswitch-switch')

    this.resizeHandler()
    this.checkCheckbox()
    this.setTextWidth()
    this.setAnchor()
  }

  resizeHandler () {
    window.addEventListener('resize', () => {
      this.resetTextWidth()
      this.setTextWidth()
    })
  }

  checkCheckbox() {
    this.checkbox.addEventListener(('change'), () => {
      document.documentElement.classList.toggle('page--blue')
      document.documentElement.classList.toggle('page--dark-blue')

      document.body.classList.toggle('bg-primary')
      document.body.classList.toggle('bg-secondary')

      this.hero.classList.toggle('bg-primary')
      this.hero.classList.toggle('bg-secondary')

      if (this.footer) {
        this.footer.classList.toggle('bg-primary')
        this.footer.classList.toggle('bg-secondary')
      }

      if (this.anchorButton) {
        this.anchorButton.classList.toggle('hero--anchor-on')
      }

      if (this.heroImageWrapper) {
        this.heroImageWrapper.classList.toggle('hero--switch__image-on')
      }

      this.onOffSwitchWrapper.classList.toggle('onoffswitch-on')
    })
  }

  resetTextWidth () {
    this.textLoop((text) => {
      text.style.width = 'auto'
    })
  }

  setTextWidth () {
    this.textLoop((text) => {
      text.style.width = `${this.getLargestTextWidth()}px`
    })
  }

  textLoop(callback) {
    const switchText = [...this.onOffSwitchWrapper.querySelectorAll('.onoffswitch-switch__text')]
    switchText.forEach(text => {
      callback(text)
    })
  }

  getLargestTextWidth() {
    let textWidth = 0
    const switchText = [...this.onOffSwitchWrapper.querySelectorAll('.onoffswitch-switch__text')]
    switchText.forEach(text => {
      const {width} = text.getBoundingClientRect()
      if (width > textWidth) {
        textWidth = width
      }
    })

    return textWidth
  }

  setAnchor() {
    const scope = document.querySelector('main')
    const secondSection = scope.querySelectorAll('section')[1]

    if (this.anchorButton) {
      const link = this.anchorButton.querySelector('a')

      link.href = `#${secondSection.id}`
    }
  }
}
